import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import SuccessErrorMsg from "../../utilities/SuccessErrorMsg";
import { emailValidation } from '../../utilities/validations/inputsValidations';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
// import { useLangUrl } from '../../utilities/useLangUrl';


export default function ResetPassword() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  // const langUrl = useLangUrl()

  async function onSubmit(data) {
    try {
      await axios.patch(
        `${process.env.REACT_APP_MASAR_API_URL}/auth/forgotpassword`, data,
        {
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      )
      toast.success(t("Active Link"))
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } catch (error) {
      console.error("An error occurred during login", error);
      switch (error.response.status) {
        case 400:
          toast.warn(t("Email NotReg"));
          break;
        default:
          toast.warn(t("errorGetSupport"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='dashboard bg-light-beige col-12 position-relative'>
      <div className='bg-white h-50'></div>
      {loading ?
        <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>
        :
        <div className='dashboard-form container col-10 col-md-6 px-4 py-5 text-start h-50 bg-dark-orange rounded-4 border border-2 shadow border-white position-absolute top-50 start-50 translate-middle'>
          <h4 className='text-white'>{t("Reset Password")}</h4>
          <p className='text-white'>{t("Add Email")}</p>
          <form className='d-flex flex-column mx-auto my-5 gap-3 text-start' onSubmit={handleSubmit(onSubmit)}>
            <input className={`form-control ${errors.email && "border border-danger"}`} type="email" placeholder={t("Email")}
              {...register("email", { required: true, pattern: emailValidation })} />
            {errors.email && <p className='errors-msg'>{t("errorEmail")}</p>}

            <input className='btn btn-light-beige text-white' type="submit" value={t("Send")} />
          </form>
          <SuccessErrorMsg
            ToastContainer={ToastContainer}
          />
        </div>
      }
      <div className='d-none d-sm-block col-6 bg-light-beige'>
      </div>
    </div>

  )
}